import axios from 'axios';
import { html, customElement } from '@adobe/edex/ui/edex-lit';
import { Googledrive } from '@adobe/edex/ui/config/googledrive';
import * as resourceAPI from '@adobe/edex/ui/api/resource';
import { EdexDomID, EdexTagName, AdobeAnalyticsEvent } from '@adobe/edex/ui/shared/constants';
import styles from '@adobe/edex/ui/components/resource/save-to-gd/save-to-gd.lit.scss';
import { BaseAuthElement } from '@adobe/edex/ui/components/base.element';
import { openDialog } from '@adobe/edex/ui/store/routines';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { AnalyticsEvent } from '@adobe/edex/ui/constants';
import { SendToDriveDialogPayload } from '@adobe/edex/ui/types';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';
import { DownloadPayLoad } from '@adobe/edex/ui/types/payload';
import { trackTargetEvent } from '@adobe/edex/ui/shared/utils';

@customElement(EdexTagName.saveToGD)
export class SaveToGD extends BaseAuthElement {
  get useLightDom() {
    return true;
  }
  static styles = styles;
  static get properties() {
    return {
      ...super.properties,
      resourceID: { type: String },
      fileID: { type: String },
    };
  }
  resourceID: string;
  fileID: string;

  actions = {
    openDialog: openDialog.trigger,
  };

  handleClick = async () => {
    this.authGuard();

    this.track({
      event: AnalyticsEvent.resourceClickSendToGD,
      payload: { id: this.resourceID },
    });
    const accessToken = await Googledrive.getInstance().getAccessToken();
    if (!accessToken) {
      return;
    }

    const source = axios.CancelToken.source();
    this.actions.openDialog({
      id: EdexDomID.resourceSendToDriveProgressDialog,
      payload: {
        source,
      } as SendToDriveDialogPayload,
    });
    const {
      data: { link, folderName },
    } = await resourceAPI.exportToGD(this.resourceID, accessToken, this.fileID, {
      cancelToken: source.token,
    });
    Analytics.getInstance().emitEvent(AdobeAnalyticsEvent.resourceDownloadGoogle, 'Resource download to Google Drive');
    trackTargetEvent('edex-resource-save-to-gd-click');
    this.emitEvent<DownloadPayLoad>('success', { link, folderName });
  };

  render() {
    const src = '/ui/assets/googledrive-icon.png';
    return html`
      <sp-button variant="primary" @click="${this.handleClick}">
        <sp-icon slot="icon" size="s" src="${src}"></sp-icon>
        ${$t(I18nKey.sendToGoogleDrive)}
      </sp-button>
    `;
  }
}
